import { render, staticRenderFns } from "./Vans.vue?vue&type=template&id=cd71f46e&"
import script from "./Vans.vue?vue&type=script&lang=js&"
export * from "./Vans.vue?vue&type=script&lang=js&"
import style0 from "./Vans.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports